import React from "react";
import { Flex, Select, TextField } from "../../../resourses/digitallabs/one-x-ui";
import { getDMQMedicalConditions } from "../../../utils/formStorage";

const DynamicSelectIndianState = ({
  field,
  value,
  isMain,
  fieldRefs,
  normalizeIndianStateOptions,
  normalizeSelectValue,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
  indian_states_metaData,
}) => {
  const storedConditions = getDMQMedicalConditions();

  const isUserNRI = !!storedConditions?.isUserNRI;
  const isUserFN = !!storedConditions?.isUserFN;

  const fieldName = field?.name;
  const inputValue = value ?? field.default_answer ?? "";

  if (isUserNRI || isUserFN) {
    return (
      <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
        <TextField
          value={inputValue}
          placeholder="Enter"
          variant="outline"
          size="md"
          label={{
            label: renderLabelWithPrefix(isMain, field.question),
            optional: !fieldIsRequired(field),
          }}
          onBlur={() => {
            const single = validateSingleField(field);
            setErrors((prev) => ({ ...prev, ...single }));

            const validation = validateVisible();
            const valid = Object.keys(validation).length === 0;

            setIsValid(valid);

            if (typeof onFormValidityChange === "function") {
              onFormValidityChange(valid);
            }
          }}
          onChange={(e) => {
            const val = e.target.value ?? "";
            updateValue(fieldName, val);
          }}
          helperText={
            submitted && errors[fieldName]
              ? {
                  message: errors[fieldName],
                  status: "error",
                }
              : undefined
          }
        />

        {field.info_text && <div className="dfh-info-text">{field.info_text}</div>}
      </Flex>
    );
  }

  const items = normalizeIndianStateOptions(indian_states_metaData);

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <Select
        items={items}
        value={normalizeSelectValue(inputValue)}
        closeOnSelect
        searchable
        label={{
          label: renderLabelWithPrefix(isMain, field.question),
          optional: !fieldIsRequired(field),
        }}
        valuePlaceholder="Select State"
        onValueChange={(details) => {
          const selectedValue = details.value?.[0] ?? "";
          updateValue(fieldName, selectedValue);
        }}
        onBlur={() => {
          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);

          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        size="md"
        helperText={
          submitted && errors[fieldName]
            ? {
                message: errors[fieldName],
                status: "error",
              }
            : undefined
        }
      />

      {field.info_text && <div className="dfh-info-text">{field.info_text}</div>}
    </Flex>
  );
};

export default DynamicSelectIndianState;
